import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { WarehouseLocation } from 'src/app/models/WarehouseLocation';

import { ArchiveWarehouseLocation } from '../warehouse.location.actions';

@Component({
    selector: 'app-warehouse-locations-delete-modal',
    templateUrl: './warehouse-locations-delete-modal.component.html',
    styleUrls: ['./warehouse-locations-delete-modal.component.scss'],
})
export class WarehouseLocationsDeleteModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Input() warehouseLocation: WarehouseLocation;

    constructor(public activeModal: NgbActiveModal, private store: Store, private router: Router, private logger: NGXLogger) {}

    ngOnInit(): void {}

    archiveWarehouseLocation() {
        this.logger.debug('Attempt to archive warehouseLocation');
        this.subscriptions.add(
            this.store.dispatch(new ArchiveWarehouseLocation(this.warehouseLocation.uuid)).subscribe(
                () => {
                    this.logger.debug('Succesfully archived warehouseLocation');
                    this.activeModal.close();
                    this.logger.debug('Navigating to inventory warehouseLocations');
                    this.router.navigate(['/inventory/warehouse-locations']);
                },
                (error) => {
                    this.logger.debug('Failed to archived warehouseLocation');
                },
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
